import TransactionIcon from './TransactionIcon'

export default TransactionIcon
